import {deepClone, executeQuery, isEmpty} from "@/main";
import evasioneRichiesta from "raw-loader!./graphQL/query/evasioneRichiesta.graphql";
import pdfRichiestaLatitudine from "raw-loader!./graphQL/query/pdfRichiestaLatitudine.graphql";
import getPolizzeAnagrafica from "raw-loader!./graphQL/query/getPolizzeAnagrafica.graphql";
import getAnagrafiche from "raw-loader!./graphQL/query/getAnagrafiche.graphql";
import getAnagraficheDaCerved from "raw-loader!./graphQL/query/getAnagraficheDaCerved.graphql";
import getProvince from "raw-loader!./graphQL/query/getProvince.graphql";
import getNazioni from "raw-loader!./graphQL/query/getNazioni.graphql";
import getStoricoUpload from "raw-loader!./graphQL/query/getStoricoUpload.graphql";
import getDettaglioStoricoUpload from "raw-loader!./graphQL/query/getDettaglioStoricoUpload.graphql";
import getDettagliLatitudini from "raw-loader!./graphQL/query/getDettagliLatitudini.graphql";
import processaLatitudine from "raw-loader!./graphQL/mutation/processaLatitudineCoface.graphql";
import processaLatitudineCerved from "raw-loader!./graphQL/mutation/processaLatitudineCerved.graphql";
import disdettaLatitudine from "raw-loader!./graphQL/mutation/disdettaLatitudine.graphql";
import disdettaLatitudineMassiva from "raw-loader!./graphQL/mutation/disdettaLatitudineMassiva.graphql";
import modifyDettaglioLatitudine from "raw-loader!./graphQL/mutation/modifyDettaglioLatitudine.graphql";
import insertStoricoUpload from "raw-loader!./graphQL/mutation/insertStoricoUpload.graphql";
import asyncUploadLatitudini from "raw-loader!./graphQL/mutation/asyncUploadLatitudini.graphql";

export default class LatitudiniService {
    asyncUploadLatitudini(user, excelFileId, polizza, excelRows){
        const variables = {
            "user": user,
            "excelFileId": excelFileId,
            "polizza": polizza,
            "excelRows": excelRows
        }
        return executeQuery(asyncUploadLatitudini, variables)
    }
    insertStoricoUpload(rowUploadHistory){
        const variables = {
            "rowUploadHistory": rowUploadHistory
        }
        return executeQuery(insertStoricoUpload, variables)
    }
    getStoricoUpload(numeroContratto){
        const variables = {
            "numeroContratto": numeroContratto
        }
        return executeQuery(getStoricoUpload, variables)
    }
    getDettaglioStoricoUpload(id){
        const variables = {
            "id": id
        }
        return executeQuery(getDettaglioStoricoUpload, variables)
    }
    disdettaLatitudineMassiva(username, latitudini, polizza){
        const variables = {
            "username": username,
            "latitudini": this.prepareMassCancel(latitudini),
            "polizza": polizza,
        }
        return executeQuery(disdettaLatitudineMassiva, variables)
    }
    disdettaLatitudine(params){
        const variables = {
            "params": params
        }
        return executeQuery(disdettaLatitudine, variables)
    }
    getEvasioneRichiesta(params) {
        const variables = {
            "params": params
        }
        return executeQuery(evasioneRichiesta, variables)
    }
    pdfRichiestaLatitudine(params) {
        const variables = {
            "params": this.trimObjectFields(params)
        }
        return executeQuery(pdfRichiestaLatitudine, variables)
    }

    getPolizzeAnagrafica(username, roleCode) {
        const variables = {
            "username": username,
            "roleCode": roleCode
        }
        return executeQuery(getPolizzeAnagrafica, variables)
    }

    getAnagrafiche(paramsInput) {
        const params = deepClone(paramsInput);
        if(!isEmpty(params.partitaIva) && params.partitaIva.startsWith("IT")){
            params.partitaIva = params.partitaIva.substr(2)
        }
        const variables = {
            "params": this.trimObjectFields(params)
        }
        return executeQuery(getAnagrafiche, variables)
    }

    getAnagraficheDaCerved(paramsInput) {
        const params = deepClone(paramsInput);
        if(!isEmpty(params.partitaIva) && params.partitaIva.startsWith("IT")){
            params.partitaIva = params.partitaIva.substr(2)
        }
        const variables = {
            "params": this.trimObjectFields(params)
        }
        return executeQuery(getAnagraficheDaCerved, variables)
    }

    getProvince() {
        return executeQuery(getProvince)
    }

    getNazioni() {
        return executeQuery(getNazioni)
    }

    getDettagliLatitudiniService(params) {
        const variables = {
            "params": params
        }
        return executeQuery(getDettagliLatitudini, variables)
    }

    modifyDettaglioLatitudine(params) {
        const variables = {
            "params": params
        }
        return executeQuery(modifyDettaglioLatitudine, variables)
    }

    processaLatitudine(params) {
        const variables = {
            "params": this.prepareParams(params)
        }
        return executeQuery(processaLatitudine, variables)
    }

    processaLatitudineCerved(params) {
        const variables = {
            "params": this.prepareParams(params)
        }
        return executeQuery(processaLatitudineCerved, variables)
    }

    prepareMassCancel(latitudini){
        latitudini.forEach(latitudine => {
            delete latitudine.dataConcComFormatted
            delete latitudine.fidoConcessoFormatted
        })
        return latitudini
    }

    prepareParams(params) {
        if (!isEmpty(params)) {
            if (!isEmpty(params.anagrafica)) {
                delete params.anagrafica.type
                delete params.anagrafica.datiSedeDTO
                isEmpty(params.anagrafica.datiSede) ? delete params.anagrafica.datiSede : ''
                isEmpty(params.anagrafica.codiceAttivita) ? delete params.anagrafica.codiceAttivita : ''
                isEmpty(params.anagrafica.anagraficaContiCorrenti) ? delete params.anagrafica.anagraficaContiCorrenti : ''
                isEmpty(params.anagrafica.tipoSocieta) ? delete params.anagrafica.tipoSocieta : ''
                isEmpty(params.anagrafica.codiceFonte) ? delete params.anagrafica.codiceFonte : ''
                isEmpty(params.anagrafica.gruppoApplicazione) ? delete params.anagrafica.gruppoApplicazione : ''
                isEmpty(params.anagrafica.name) ? delete params.anagrafica.name : ''
            }
            return this.trimObjectFields(params)
        }
    }

    trimObjectFields(obj) {
        for (let prop in obj) {
            if (typeof obj[prop] === 'string') {
                obj[prop] = obj[prop].trim();
            } else if (typeof obj[prop] === 'object') {
                this.trimObjectFields(obj[prop]);
            }
        }
        return obj
    }
}